import request from '@/utils/request'
const baseUrl = '/works'

/**
 * 联系我们
 */
export function contactUs(data) {
  return request({
    url: `${baseUrl}/rest/contactUs`,
    method: 'POST',
    data
  })
}

/**
 * 获取网站底部各链接
 */
export function getHomeText() {
  return request({
    url: `${baseUrl}/rest/getHomeText`,
    method: 'POST',
  })
}

/**
 * 作品管理-我的hdr作品
 */
export function hdrList(data) {
  return request({
    url: `${baseUrl}/private/rest/hdrList`,
    method: 'POST',
    data
  })
}

/**
 * 作品管理-我的works作品
 */
export function worksList(data) {
  return request({
    url: `${baseUrl}/private/rest/worksList`,
    method: 'POST',
    data
  })
}

/**
 * 作品管理-我的展映作品
 */
export function showList(data) {
  return request({
    url: `${baseUrl}/private/rest/showList`,
    method: 'POST',
    data
  })
}

/**
 * 作品管理-我的学院
 */
export function getPersonalCourse(data) {
  return request({
    url: `/college/private/rest/getPersonalCourse`,
    method: 'POST',
    data
  })
}
